// Bonus table data from CSV
export const bonusTableData = [
  {
    salesAnnually: 2000000,
    salesQuarterly: 500000,
    salesWeekly: 38462,
    opPrimeCostBonusPotential: 2000,
    opGuestMetricBonusPotential: 3000,
    opBonusPotential: 5000,
    managerPrimeCostBonusPotential: 600,
    managerGuestMetricBonusPotential: 900,
    managerBonusPotentialPool: 1500,
    twoManagerPerStoreIndividualManagerAverage: 750,
  },
  {
    salesAnnually: 2100000,
    salesQuarterly: 525000,
    salesWeekly: 40385,
    opPrimeCostBonusPotential: 2800,
    opGuestMetricBonusPotential: 4200,
    opBonusPotential: 7000,
    managerPrimeCostBonusPotential: 700,
    managerGuestMetricBonusPotential: 1050,
    managerBonusPotentialPool: 1750,
    twoManagerPerStoreIndividualManagerAverage: 875,
  },
  {
    salesAnnually: 2200000,
    salesQuarterly: 550000,
    salesWeekly: 42308,
    opPrimeCostBonusPotential: 3600,
    opGuestMetricBonusPotential: 5400,
    opBonusPotential: 9000,
    managerPrimeCostBonusPotential: 800,
    managerGuestMetricBonusPotential: 1200,
    managerBonusPotentialPool: 2000,
    twoManagerPerStoreIndividualManagerAverage: 1000,
  },
  {
    salesAnnually: 2300000,
    salesQuarterly: 575000,
    salesWeekly: 44231,
    opPrimeCostBonusPotential: 4400,
    opGuestMetricBonusPotential: 6600,
    opBonusPotential: 11000,
    managerPrimeCostBonusPotential: 900,
    managerGuestMetricBonusPotential: 1350,
    managerBonusPotentialPool: 2250,
    twoManagerPerStoreIndividualManagerAverage: 1125,
  },
  {
    salesAnnually: 2400000,
    salesQuarterly: 600000,
    salesWeekly: 46154,
    opPrimeCostBonusPotential: 5200,
    opGuestMetricBonusPotential: 7800,
    opBonusPotential: 13000,
    managerPrimeCostBonusPotential: 1000,
    managerGuestMetricBonusPotential: 1500,
    managerBonusPotentialPool: 2500,
    twoManagerPerStoreIndividualManagerAverage: 1250,
  },
  {
    salesAnnually: 2500000,
    salesQuarterly: 625000,
    salesWeekly: 48077,
    opPrimeCostBonusPotential: 6000,
    opGuestMetricBonusPotential: 9000,
    opBonusPotential: 15000,
    managerPrimeCostBonusPotential: 1100,
    managerGuestMetricBonusPotential: 1650,
    managerBonusPotentialPool: 2750,
    twoManagerPerStoreIndividualManagerAverage: 1375,
  },
  {
    salesAnnually: 2600000,
    salesQuarterly: 650000,
    salesWeekly: 50000,
    opPrimeCostBonusPotential: 6800,
    opGuestMetricBonusPotential: 10200,
    opBonusPotential: 17000,
    managerPrimeCostBonusPotential: 1200,
    managerGuestMetricBonusPotential: 1800,
    managerBonusPotentialPool: 3000,
    twoManagerPerStoreIndividualManagerAverage: 1500,
  },
  {
    salesAnnually: 2700000,
    salesQuarterly: 675000,
    salesWeekly: 51923,
    opPrimeCostBonusPotential: 7600,
    opGuestMetricBonusPotential: 11400,
    opBonusPotential: 19000,
    managerPrimeCostBonusPotential: 1300,
    managerGuestMetricBonusPotential: 1950,
    managerBonusPotentialPool: 3250,
    twoManagerPerStoreIndividualManagerAverage: 1625,
  },
  {
    salesAnnually: 2800000,
    salesQuarterly: 700000,
    salesWeekly: 53846,
    opPrimeCostBonusPotential: 8400,
    opGuestMetricBonusPotential: 12600,
    opBonusPotential: 21000,
    managerPrimeCostBonusPotential: 1400,
    managerGuestMetricBonusPotential: 2100,
    managerBonusPotentialPool: 3500,
    twoManagerPerStoreIndividualManagerAverage: 1750,
  },
  {
    salesAnnually: 2900000,
    salesQuarterly: 725000,
    salesWeekly: 55769,
    opPrimeCostBonusPotential: 9200,
    opGuestMetricBonusPotential: 13800,
    opBonusPotential: 23000,
    managerPrimeCostBonusPotential: 1500,
    managerGuestMetricBonusPotential: 2250,
    managerBonusPotentialPool: 3750,
    twoManagerPerStoreIndividualManagerAverage: 1875,
  },
  {
    salesAnnually: 3000000,
    salesQuarterly: 750000,
    salesWeekly: 57692,
    opPrimeCostBonusPotential: 10000,
    opGuestMetricBonusPotential: 15000,
    opBonusPotential: 25000,
    managerPrimeCostBonusPotential: 1600,
    managerGuestMetricBonusPotential: 2400,
    managerBonusPotentialPool: 4000,
    twoManagerPerStoreIndividualManagerAverage: 2000,
  },
  {
    salesAnnually: 3100000,
    salesQuarterly: 775000,
    salesWeekly: 59615,
    opPrimeCostBonusPotential: 10800,
    opGuestMetricBonusPotential: 16200,
    opBonusPotential: 27000,
    managerPrimeCostBonusPotential: 1700,
    managerGuestMetricBonusPotential: 2550,
    managerBonusPotentialPool: 4250,
    twoManagerPerStoreIndividualManagerAverage: 2125,
  },
  {
    salesAnnually: 3200000,
    salesQuarterly: 800000,
    salesWeekly: 61538,
    opPrimeCostBonusPotential: 11600,
    opGuestMetricBonusPotential: 17400,
    opBonusPotential: 29000,
    managerPrimeCostBonusPotential: 1800,
    managerGuestMetricBonusPotential: 2700,
    managerBonusPotentialPool: 4500,
    twoManagerPerStoreIndividualManagerAverage: 2250,
  },
  {
    salesAnnually: 3300000,
    salesQuarterly: 825000,
    salesWeekly: 63462,
    opPrimeCostBonusPotential: 12400,
    opGuestMetricBonusPotential: 18600,
    opBonusPotential: 31000,
    managerPrimeCostBonusPotential: 1900,
    managerGuestMetricBonusPotential: 2850,
    managerBonusPotentialPool: 4750,
    twoManagerPerStoreIndividualManagerAverage: 2375,
  },
  {
    salesAnnually: 3400000,
    salesQuarterly: 850000,
    salesWeekly: 65385,
    opPrimeCostBonusPotential: 13200,
    opGuestMetricBonusPotential: 19800,
    opBonusPotential: 33000,
    managerPrimeCostBonusPotential: 2000,
    managerGuestMetricBonusPotential: 3000,
    managerBonusPotentialPool: 5000,
    twoManagerPerStoreIndividualManagerAverage: 2500,
  },
  {
    salesAnnually: 3500000,
    salesQuarterly: 875000,
    salesWeekly: 67308,
    opPrimeCostBonusPotential: 14000,
    opGuestMetricBonusPotential: 21000,
    opBonusPotential: 35000,
    managerPrimeCostBonusPotential: 2100,
    managerGuestMetricBonusPotential: 3150,
    managerBonusPotentialPool: 5250,
    twoManagerPerStoreIndividualManagerAverage: 2625,
  },
  {
    salesAnnually: 3600000,
    salesQuarterly: 900000,
    salesWeekly: 69231,
    opPrimeCostBonusPotential: 14800,
    opGuestMetricBonusPotential: 22200,
    opBonusPotential: 37000,
    managerPrimeCostBonusPotential: 2200,
    managerGuestMetricBonusPotential: 3300,
    managerBonusPotentialPool: 5500,
    twoManagerPerStoreIndividualManagerAverage: 2750,
  },
  {
    salesAnnually: 3700000,
    salesQuarterly: 925000,
    salesWeekly: 71154,
    opPrimeCostBonusPotential: 15600,
    opGuestMetricBonusPotential: 23400,
    opBonusPotential: 39000,
    managerPrimeCostBonusPotential: 2300,
    managerGuestMetricBonusPotential: 3450,
    managerBonusPotentialPool: 5750,
    twoManagerPerStoreIndividualManagerAverage: 2875,
  },
  {
    salesAnnually: 3800000,
    salesQuarterly: 950000,
    salesWeekly: 73077,
    opPrimeCostBonusPotential: 16400,
    opGuestMetricBonusPotential: 24600,
    opBonusPotential: 41000,
    managerPrimeCostBonusPotential: 2400,
    managerGuestMetricBonusPotential: 3600,
    managerBonusPotentialPool: 6000,
    twoManagerPerStoreIndividualManagerAverage: 3000,
  },
  {
    salesAnnually: 3900000,
    salesQuarterly: 975000,
    salesWeekly: 75000,
    opPrimeCostBonusPotential: 17200,
    opGuestMetricBonusPotential: 25800,
    opBonusPotential: 43000,
    managerPrimeCostBonusPotential: 2500,
    managerGuestMetricBonusPotential: 3750,
    managerBonusPotentialPool: 6250,
    twoManagerPerStoreIndividualManagerAverage: 3125,
  },
  {
    salesAnnually: 4000000,
    salesQuarterly: 1000000,
    salesWeekly: 76923,
    opPrimeCostBonusPotential: 18000,
    opGuestMetricBonusPotential: 27000,
    opBonusPotential: 45000,
    managerPrimeCostBonusPotential: 2600,
    managerGuestMetricBonusPotential: 3900,
    managerBonusPotentialPool: 6500,
    twoManagerPerStoreIndividualManagerAverage: 3250,
  },
  {
    salesAnnually: 4100000,
    salesQuarterly: 1025000,
    salesWeekly: 78846,
    opPrimeCostBonusPotential: 18800,
    opGuestMetricBonusPotential: 28200,
    opBonusPotential: 47000,
    managerPrimeCostBonusPotential: 2700,
    managerGuestMetricBonusPotential: 4050,
    managerBonusPotentialPool: 6750,
    twoManagerPerStoreIndividualManagerAverage: 3375,
  },
  {
    salesAnnually: 4200000,
    salesQuarterly: 1050000,
    salesWeekly: 80769,
    opPrimeCostBonusPotential: 19600,
    opGuestMetricBonusPotential: 29400,
    opBonusPotential: 49000,
    managerPrimeCostBonusPotential: 2800,
    managerGuestMetricBonusPotential: 4200,
    managerBonusPotentialPool: 7000,
    twoManagerPerStoreIndividualManagerAverage: 3500,
  },
  {
    salesAnnually: 4300000,
    salesQuarterly: 1075000,
    salesWeekly: 82692,
    opPrimeCostBonusPotential: 20400,
    opGuestMetricBonusPotential: 30600,
    opBonusPotential: 51000,
    managerPrimeCostBonusPotential: 2900,
    managerGuestMetricBonusPotential: 4350,
    managerBonusPotentialPool: 7250,
    twoManagerPerStoreIndividualManagerAverage: 3625,
  },
  {
    salesAnnually: 4400000,
    salesQuarterly: 1100000,
    salesWeekly: 84615,
    opPrimeCostBonusPotential: 21200,
    opGuestMetricBonusPotential: 31800,
    opBonusPotential: 53000,
    managerPrimeCostBonusPotential: 3000,
    managerGuestMetricBonusPotential: 4500,
    managerBonusPotentialPool: 7500,
    twoManagerPerStoreIndividualManagerAverage: 3750,
  },
  {
    salesAnnually: 4500000,
    salesQuarterly: 1125000,
    salesWeekly: 86538,
    opPrimeCostBonusPotential: 22000,
    opGuestMetricBonusPotential: 33000,
    opBonusPotential: 55000,
    managerPrimeCostBonusPotential: 3100,
    managerGuestMetricBonusPotential: 4650,
    managerBonusPotentialPool: 7750,
    twoManagerPerStoreIndividualManagerAverage: 3875,
  },
  {
    salesAnnually: 4600000,
    salesQuarterly: 1150000,
    salesWeekly: 88462,
    opPrimeCostBonusPotential: 22800,
    opGuestMetricBonusPotential: 34200,
    opBonusPotential: 57000,
    managerPrimeCostBonusPotential: 3200,
    managerGuestMetricBonusPotential: 4800,
    managerBonusPotentialPool: 8000,
    twoManagerPerStoreIndividualManagerAverage: 4000,
  },
  {
    salesAnnually: 4700000,
    salesQuarterly: 1175000,
    salesWeekly: 90385,
    opPrimeCostBonusPotential: 23600,
    opGuestMetricBonusPotential: 35400,
    opBonusPotential: 59000,
    managerPrimeCostBonusPotential: 3300,
    managerGuestMetricBonusPotential: 4950,
    managerBonusPotentialPool: 8250,
    twoManagerPerStoreIndividualManagerAverage: 4125,
  },
  {
    salesAnnually: 4800000,
    salesQuarterly: 1200000,
    salesWeekly: 92308,
    opPrimeCostBonusPotential: 24400,
    opGuestMetricBonusPotential: 36600,
    opBonusPotential: 61000,
    managerPrimeCostBonusPotential: 3400,
    managerGuestMetricBonusPotential: 5100,
    managerBonusPotentialPool: 8500,
    twoManagerPerStoreIndividualManagerAverage: 4250,
  },
  {
    salesAnnually: 4900000,
    salesQuarterly: 1225000,
    salesWeekly: 94231,
    opPrimeCostBonusPotential: 25200,
    opGuestMetricBonusPotential: 37800,
    opBonusPotential: 63000,
    managerPrimeCostBonusPotential: 3500,
    managerGuestMetricBonusPotential: 5250,
    managerBonusPotentialPool: 8750,
    twoManagerPerStoreIndividualManagerAverage: 4375,
  },
  {
    salesAnnually: 5000000,
    salesQuarterly: 1250000,
    salesWeekly: 96154,
    opPrimeCostBonusPotential: 26000,
    opGuestMetricBonusPotential: 39000,
    opBonusPotential: 65000,
    managerPrimeCostBonusPotential: 3600,
    managerGuestMetricBonusPotential: 5400,
    managerBonusPotentialPool: 9000,
    twoManagerPerStoreIndividualManagerAverage: 4500,
  },
  {
    salesAnnually: 5100000,
    salesQuarterly: 1275000,
    salesWeekly: 98077,
    opPrimeCostBonusPotential: 26800,
    opGuestMetricBonusPotential: 40200,
    opBonusPotential: 67000,
    managerPrimeCostBonusPotential: 3700,
    managerGuestMetricBonusPotential: 5550,
    managerBonusPotentialPool: 9250,
    twoManagerPerStoreIndividualManagerAverage: 4625,
  },
  {
    salesAnnually: 5200000,
    salesQuarterly: 1300000,
    salesWeekly: 100000,
    opPrimeCostBonusPotential: 27600,
    opGuestMetricBonusPotential: 41400,
    opBonusPotential: 69000,
    managerPrimeCostBonusPotential: 3800,
    managerGuestMetricBonusPotential: 5700,
    managerBonusPotentialPool: 9500,
    twoManagerPerStoreIndividualManagerAverage: 4750,
  },
  {
    salesAnnually: 5300000,
    salesQuarterly: 1325000,
    salesWeekly: 101923,
    opPrimeCostBonusPotential: 28400,
    opGuestMetricBonusPotential: 42600,
    opBonusPotential: 71000,
    managerPrimeCostBonusPotential: 3900,
    managerGuestMetricBonusPotential: 5850,
    managerBonusPotentialPool: 9750,
    twoManagerPerStoreIndividualManagerAverage: 4875,
  },
  {
    salesAnnually: 5400000,
    salesQuarterly: 1350000,
    salesWeekly: 103846,
    opPrimeCostBonusPotential: 29200,
    opGuestMetricBonusPotential: 43800,
    opBonusPotential: 73000,
    managerPrimeCostBonusPotential: 4000,
    managerGuestMetricBonusPotential: 6000,
    managerBonusPotentialPool: 10000,
    twoManagerPerStoreIndividualManagerAverage: 5000,
  },
  {
    salesAnnually: 5500000,
    salesQuarterly: 1375000,
    salesWeekly: 105769,
    opPrimeCostBonusPotential: 30000,
    opGuestMetricBonusPotential: 45000,
    opBonusPotential: 75000,
    managerPrimeCostBonusPotential: 4100,
    managerGuestMetricBonusPotential: 6150,
    managerBonusPotentialPool: 10250,
    twoManagerPerStoreIndividualManagerAverage: 5125,
  },
  {
    salesAnnually: 5600000,
    salesQuarterly: 1400000,
    salesWeekly: 107692,
    opPrimeCostBonusPotential: 30800,
    opGuestMetricBonusPotential: 46200,
    opBonusPotential: 77000,
    managerPrimeCostBonusPotential: 4200,
    managerGuestMetricBonusPotential: 6300,
    managerBonusPotentialPool: 10500,
    twoManagerPerStoreIndividualManagerAverage: 5250,
  },
  {
    salesAnnually: 5700000,
    salesQuarterly: 1425000,
    salesWeekly: 109615,
    opPrimeCostBonusPotential: 31600,
    opGuestMetricBonusPotential: 47400,
    opBonusPotential: 79000,
    managerPrimeCostBonusPotential: 4300,
    managerGuestMetricBonusPotential: 6450,
    managerBonusPotentialPool: 10750,
    twoManagerPerStoreIndividualManagerAverage: 5375,
  },
  {
    salesAnnually: 5800000,
    salesQuarterly: 1450000,
    salesWeekly: 111538,
    opPrimeCostBonusPotential: 32400,
    opGuestMetricBonusPotential: 48600,
    opBonusPotential: 81000,
    managerPrimeCostBonusPotential: 4400,
    managerGuestMetricBonusPotential: 6600,
    managerBonusPotentialPool: 11000,
    twoManagerPerStoreIndividualManagerAverage: 5500,
  },
  {
    salesAnnually: 5900000,
    salesQuarterly: 1475000,
    salesWeekly: 113462,
    opPrimeCostBonusPotential: 33200,
    opGuestMetricBonusPotential: 49800,
    opBonusPotential: 83000,
    managerPrimeCostBonusPotential: 4500,
    managerGuestMetricBonusPotential: 6750,
    managerBonusPotentialPool: 11250,
    twoManagerPerStoreIndividualManagerAverage: 5625,
  },
  {
    salesAnnually: 6000000,
    salesQuarterly: 1500000,
    salesWeekly: 115385,
    opPrimeCostBonusPotential: 34000,
    opGuestMetricBonusPotential: 51000,
    opBonusPotential: 85000,
    managerPrimeCostBonusPotential: 4600,
    managerGuestMetricBonusPotential: 6900,
    managerBonusPotentialPool: 11500,
    twoManagerPerStoreIndividualManagerAverage: 5750,
  },
  {
    salesAnnually: 6100000,
    salesQuarterly: 1525000,
    salesWeekly: 117308,
    opPrimeCostBonusPotential: 34800,
    opGuestMetricBonusPotential: 52200,
    opBonusPotential: 87000,
    managerPrimeCostBonusPotential: 4700,
    managerGuestMetricBonusPotential: 7050,
    managerBonusPotentialPool: 11750,
    twoManagerPerStoreIndividualManagerAverage: 5875,
  },
  {
    salesAnnually: 6200000,
    salesQuarterly: 1550000,
    salesWeekly: 119231,
    opPrimeCostBonusPotential: 35600,
    opGuestMetricBonusPotential: 53400,
    opBonusPotential: 89000,
    managerPrimeCostBonusPotential: 4800,
    managerGuestMetricBonusPotential: 7200,
    managerBonusPotentialPool: 12000,
    twoManagerPerStoreIndividualManagerAverage: 6000,
  },
  {
    salesAnnually: 6300000,
    salesQuarterly: 1575000,
    salesWeekly: 121154,
    opPrimeCostBonusPotential: 36400,
    opGuestMetricBonusPotential: 54600,
    opBonusPotential: 91000,
    managerPrimeCostBonusPotential: 4900,
    managerGuestMetricBonusPotential: 7350,
    managerBonusPotentialPool: 12250,
    twoManagerPerStoreIndividualManagerAverage: 6125,
  },
  {
    salesAnnually: 6400000,
    salesQuarterly: 1600000,
    salesWeekly: 123077,
    opPrimeCostBonusPotential: 37200,
    opGuestMetricBonusPotential: 55800,
    opBonusPotential: 93000,
    managerPrimeCostBonusPotential: 5000,
    managerGuestMetricBonusPotential: 7500,
    managerBonusPotentialPool: 12500,
    twoManagerPerStoreIndividualManagerAverage: 6250,
  },
  {
    salesAnnually: 6500000,
    salesQuarterly: 1625000,
    salesWeekly: 125000,
    opPrimeCostBonusPotential: 38000,
    opGuestMetricBonusPotential: 57000,
    opBonusPotential: 95000,
    managerPrimeCostBonusPotential: 5100,
    managerGuestMetricBonusPotential: 7650,
    managerBonusPotentialPool: 12750,
    twoManagerPerStoreIndividualManagerAverage: 6375,
  },
  {
    salesAnnually: 6600000,
    salesQuarterly: 1650000,
    salesWeekly: 126923,
    opPrimeCostBonusPotential: 38800,
    opGuestMetricBonusPotential: 58200,
    opBonusPotential: 97000,
    managerPrimeCostBonusPotential: 5200,
    managerGuestMetricBonusPotential: 7800,
    managerBonusPotentialPool: 13000,
    twoManagerPerStoreIndividualManagerAverage: 6500,
  },
  {
    salesAnnually: 6700000,
    salesQuarterly: 1675000,
    salesWeekly: 128846,
    opPrimeCostBonusPotential: 39600,
    opGuestMetricBonusPotential: 59400,
    opBonusPotential: 99000,
    managerPrimeCostBonusPotential: 5300,
    managerGuestMetricBonusPotential: 7950,
    managerBonusPotentialPool: 13250,
    twoManagerPerStoreIndividualManagerAverage: 6625,
  },
  {
    salesAnnually: 6800000,
    salesQuarterly: 1700000,
    salesWeekly: 130769,
    opPrimeCostBonusPotential: 40400,
    opGuestMetricBonusPotential: 60600,
    opBonusPotential: 101000,
    managerPrimeCostBonusPotential: 5400,
    managerGuestMetricBonusPotential: 8100,
    managerBonusPotentialPool: 13500,
    twoManagerPerStoreIndividualManagerAverage: 6750,
  },
  {
    salesAnnually: 6900000,
    salesQuarterly: 1725000,
    salesWeekly: 132692,
    opPrimeCostBonusPotential: 41200,
    opGuestMetricBonusPotential: 61800,
    opBonusPotential: 103000,
    managerPrimeCostBonusPotential: 5500,
    managerGuestMetricBonusPotential: 8250,
    managerBonusPotentialPool: 13750,
    twoManagerPerStoreIndividualManagerAverage: 6875,
  },
  {
    salesAnnually: 7000000,
    salesQuarterly: 1750000,
    salesWeekly: 134615,
    opPrimeCostBonusPotential: 42000,
    opGuestMetricBonusPotential: 63000,
    opBonusPotential: 105000,
    managerPrimeCostBonusPotential: 5600,
    managerGuestMetricBonusPotential: 8400,
    managerBonusPotentialPool: 14000,
    twoManagerPerStoreIndividualManagerAverage: 7000,
  },
]

// Metric codes for data fetching
// why: labor_variance is intentionally NOT in this list - it is queried
// separately with its date range clamped to the last posted labor week
// (ENG-5468, see laborVarianceMetricCodes below).
export const metricCodes = [
  'bonus_attainment_percent_quarter',
  'net_sales',
  'average_weekly_sales_quarter',
  'bonus_sales_to_next_band',
  'food_and_beverage_variance',
  'large_meat_variance',
  'paper_variance',
  'total_prime_cost_variance',
  'qualtrics_osat_percent',
  'google_rating',
  'delivery_avg_customer_review_score_doordash',
  'hme_goal_percent',
  'qualtrics_speed_of_service_percent', // Added for store 1682 exception
  'qualtrics_drive_thru_wait_time_percent',
  'bonus_op_prime_cost_quarter',
  'bonus_op_guest_metric_quarter',
  'bonus_op_total_quarter',
  'bonus_op_missed_opportunity_quarter',
  'bonus_manager_prime_cost_quarter',
  'bonus_manager_guest_metric_quarter',
  'bonus_manager_total_quarter',
  'bonus_manager_missed_opportunity_quarter',
]

// why: queried separately from metricCodes with the endDate clamped to the
// last business day with posted variable_labor, so the CALCULATED metric's
// labor numerator and sales denominator cover the same weeks (ENG-5468).
export const laborVarianceMetricCodes = ['labor_variance']

export const ROWS_PER_PAGE = 20
